import { PiRegister, createCardDeclaration } from "@pihanga/core";

import { Component } from "./tbImgSegmentViewer.component";
import type { ComponentProps } from "./tbImgSegmentViewer.component";

export const CARD_TYPE = "TbImgSegmentViewer";
export const TbImgSegmentViewer =
  createCardDeclaration<ComponentProps>(CARD_TYPE);

export function init(register: PiRegister): void {
  register.cardComponent({
    name: CARD_TYPE,
    component: Component,
  });
}
